import { Button } from "@/src/components/buttons";
import { closeDialog, openDialog } from "@/src/components/dialogs";
import { FieldAnswer, Patient, RefAnswer, Reference } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId } from "@/src/utils/utils";
import moment from "moment";
import { ReferenceFieldsForm } from "../../fields/referenceFieldsForm";
import { openAnswersTimelineForm } from "./answersTimelineForm";

export async function openAnswerTimelineActions({
  answer,
  patient,
  reference,
  onChange,
}: {
  answer: FieldAnswer;
  patient: Patient;
  reference: Reference;
  onChange: (newValue: FieldAnswer | null | undefined) => void;
}) {
  function close() {
    closeDialog("taskActionsDialog");
  }
  return await openDialog({
    id: "taskActionsDialog",
    title: "Actions",

    content: (
      <div className="c1 gap10">
        <Button
          onClick={async () => {
            await openAnswersTimelineForm({
              patient,
              reference,
              fieldAnswer: answer,
              field: answer.field!,
              start: answer.start!,
              onSave: (answer) => {
                onChange(answer);
                close();
              },
            });
          }}
        >
          Modifier
        </Button>
        <Button
          type="tertiary"
          onClick={async () => {
            if (answer.status == "finished") {
              answer.status = "pending";
            } else {
              answer.status = "finished";
              answer.finishedDate = moment().format("YYYY-MM-DD HH:mm:ss");
              answer.doctor = getUserId();
            }
            await apiFetch(
              "fieldAnswers",
              "addOne",
              { fieldAnswer: answer },
              "Erreur lors de la mise à jour de la tâche"
            );
            onChange(answer);
            close();
          }}
        >
          {answer.status == "finished"
            ? "Marquer comme non fait"
            : "Marquer comme fait"}
        </Button>
        <Button
          color="red"
          type="tertiary"
          onClick={async () => {
            if (!answer) throw new Error("Answer is not defined");
            await apiFetch("general", "deleteAny", {
              id: answer.id,
              table: "fieldAnswers",
            });
            onChange(null);
            close();
          }}
        >
          Supprimer
        </Button>
      </div>
    ),
  });
}
